export const CARD_HISTORY = 'saison/cardHistory'
